import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Divider, Form, FormProps, Typography } from 'antd';
import { FC, Fragment } from 'react';
import { CartogramLegendSettings } from '../../types';
import { LegendSettingsFormItems } from './LegendSettingsFormItems';
import { ValidatorRule } from '@rc-component/form/lib/interface';

import './style.scss';

const { Title } = Typography;

export interface LegendsSettingsFormInstance {
  settings: CartogramLegendSettings[];
}

export interface LegendSettingsFormProps extends FormProps {}

export const LegendSettingsForm: FC<LegendSettingsFormProps> = ({
  className = '',
  ...props
}) => {
  const legendsValidationRule: ValidatorRule = {
    validator: async (_, items) => {
      if (!items || items.length === 0)
        throw new Error('Необходимо добавить легенду');

      return undefined;
    },
  };

  const renderAddButton = (
    addLegendSettings: (
      initialValues?: Partial<CartogramLegendSettings>,
    ) => void,
  ) => (
    <Button
      type="link"
      className="cartogram-legends__settings__add-button"
      icon={<PlusOutlined />}
      onClick={() =>
        addLegendSettings({ minValue: 0, maxValue: 0, color: '#cccccc' })
      }
    >
      Добавить легенду
    </Button>
  );

  return (
    <Form className={`cartogram-legends-form ${className}}`} {...props}>
      <Form.List name="settings" rules={[legendsValidationRule]}>
        {(legendsSettings, { add, remove }, errors) => (
          <div className="cartogram-legends">
            <div className="cartogram-legends__header-container">
              <Title level={5} className="cartogram-legends__title">
                Настройки легенды
              </Title>

              {!!legendsSettings?.length && renderAddButton(add)}
            </div>

            {!!legendsSettings?.length && (
              <Card className="cartogram-legends__settings-card">
                {legendsSettings.map((item, index) => (
                  <Fragment key={item.name}>
                    <LegendSettingsFormItems
                      formItemName={item.name}
                      onCloseClick={() => remove(index)}
                    />
                    {index + 1 !== legendsSettings.length && (
                      <Divider className="cartogram-legends__settings-card__separator" />
                    )}
                  </Fragment>
                ))}
              </Card>
            )}

            {!legendsSettings?.length && renderAddButton(add)}

            <Form.ErrorList {...errors} />
          </div>
        )}
      </Form.List>
    </Form>
  );
};
